<template>
  <v-dialog
    v-model="show"
    max-width="430"
  >
    <v-alert prominent class="mb-0" type="info">
      <p>21년 7월, <span class="font-weight-bold">HD현대에너지솔루션 모니터링시스템</span>의</p>
      <p>새로운 모습을 여러분의 사업에 펼쳐드리겠습니다.</p>
    </v-alert>
  </v-dialog>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
// [ECMA6] export default 된 부분이 외부에서 import로 사용할 수 있게 된다.
import day from 'dayjs'
export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'OpenAlertDialog',
  props: {
    showEvent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.

  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행

  },
  watch: {
    showEvent(newValue) {
      this.show = true
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
/* 퍼블리셔 작업 영역 */

// lang="less"로 <style> 태그에 속성으로 넣어야 less를 사용할 수 있다.

.test-box {
  border: 1px solid lightgreen;
}
</style>
